export default "__VITE_ASSET__DUB_7HdB__"